import { RuleObject } from 'antd/lib/form';
import { StoreValue } from 'antd/lib/form/interface';

const useValidateNoWhiteSpace = () => {
  return () => ({
    validator: (_: RuleObject, value: StoreValue): Promise<void> => {
      if (value && typeof value === 'string' && value.trim() === '') {
        return Promise.reject(new Error('Não é permitido espaços em branco'));
      }
      return Promise.resolve();
    },
  });
};

export default useValidateNoWhiteSpace;
